<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <user-menu></user-menu>
      <!-- <mobile-menu></mobile-menu> -->
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{name: 'Licencias', icon: 'nc-icon nc-circle-09', path: '/'}">
          <sidebar-item :link="{name: 'Crear', path: '/admin/options/new'}"></sidebar-item>
          <sidebar-item :link="{name: 'Lista', path: '/admin/options/list'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Instituciones', icon: 'nc-icon nc-single-02', path: '/'}">
          <sidebar-item :link="{name: 'Crear', path: '/admin/options/institutions/new'}"></sidebar-item>
          <sidebar-item :link="{name: 'Lista', path: '/admin/options/institutions/active'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Identificador', icon: 'nc-icon nc-tablet-2', path: '/'}">
          <sidebar-item :link="{name: 'Crear', path: '/admin/options/identifier/new'}"></sidebar-item>
          <sidebar-item :link="{name: 'Lista', path: '/admin/options/identifier/list'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Opciones', icon: 'nc-icon nc-tablet-2', path: '/'}">
          <sidebar-item :link="{name: 'Crear', path: '/admin/options/options/new'}"></sidebar-item>
          <sidebar-item :link="{name: 'Lista', path: '/admin/options/options/list'}"></sidebar-item>
        </sidebar-item>

              <sidebar-item :link="{name: 'Ambientes', icon: 'nc-icon nc-tablet-2', path: '/'}">
          <sidebar-item :link="{name: 'Crear', path: '/admin/options/ambiente/new'}"></sidebar-item>
          <sidebar-item :link="{name: 'Lista', path: '/admin/options/ambiente/list'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Histórico', icon: 'nc-icon nc-money-coins', path:'/admin/options/historico'}">

        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './Extra/MobileMenu.vue'
  import UserMenu from './Extra/UserMenu.vue'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu,
      UserMenu
    },
    data() {
      return {}
    },
        methods: {
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false)
                }
            }
        },
    }

</script>
